export default {
	/**
	 * CSS id for cart container element
	 * @const
	 * @type {string}
	 * @default
	 */
	SAVED_CARTS_ID: 'cart-saved',
	/**
	 * CSS id for cart list element
	 * @const
	 * @type {string}
	 * @default
	 */
	CART_GALLERY_ID: 'cart-assets',
	/**
	 * CSS id for cart actions bar element
	 * @const
	 * @type {string}
	 * @default
	 */
	CART_ACTIONS_BAR: 'cart-actions-bar',
	/**
	 * CSS id for cart list header element
	 * @const
	 * @type {string}
	 * @default
	 */
	CART_HEADER_ID: 'cart-header',
	/**
	 * CSS id for saved cart header container element
	 * @const
	 * @type {string}
	 * @default
	 */
	SAVED_CART_HEADER_ID: 'saved-cart-header',
	/**
	 * CSS id for saved cart assets container element
	 * @const
	 * @type {string}
	 * @default
	 */
	SAVED_CART_GALLERY_ID: 'saved-cart-assets',

	/**
	 * CSS id for cart container element
	 * @const
	 * @type {string}
	 * @default
	 */
	CHUNK_SIZE: 12,
	/**
	 * CSS id for cart container element
	 * @const
	 * @type {string}
	 * @default
	 */
	PAGE_SIZE: 12,
	/**
	 * Route component for showing the contents a saved cart
	 * @const
	 * @type {string}
	 * @default
	 */
	ROUTE_SAVED_CART: 'cart-assets',
};
